import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'currencyTranslate'
})
export class CurrencyTranslatePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
    private decimalPipe: DecimalPipe,
    private currencyPipe: CurrencyPipe
  ) {
  }

  transform(value: number, short: boolean = true, digitsInfo?: string): any {
    if (!digitsInfo) {
      digitsInfo = '1.0-0';
    }
    value = value ? value : 0;
    if (short) {
      return this.currencyPipe.transform(value, 'THB', 'symbol-narrow', digitsInfo, 'th');
    }
    return this.decimalPipe.transform(value, digitsInfo)
      + (' ' + (this.translate.currentLang === 'th' ? 'บาท' : 'Baht'));
  }

}

// <!-- <ng-container *ngIf="translate.currentLang === 'en'">{{ value | currency }}</ng-container>-->
// <!-- <ng-container *ngIf="translate.currentLang === 'th'">{{ value | currency:'฿':'symbol':'1.2-2':'th' }}</ng-container>-->
